var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFinetuneParametersTermbase = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.58 10.047 6.887 8.373l.02-.02A11.7 11.7 0 0 0 9.38 4h1.953V2.667H6.667V1.333H5.333v1.334H.667v1.326h7.446A10.5 10.5 0 0 1 6 7.567a10.4 10.4 0 0 1-1.54-2.234H3.127a11.7 11.7 0 0 0 1.986 3.04L1.72 11.72l.947.947L6 9.333l2.073 2.074zm3.753-3.38H11l-3 8h1.333l.747-2h3.167l.753 2h1.333zm-1.746 4.666 1.08-2.886 1.08 2.886z"
})));
export default SvgFinetuneParametersTermbase;